const { CONSTANTS } = require('../../config')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} brand
 * @param {string} country
 * @returns {string|*}
 */
function getGABrand ({ brand, country } = {}) {
  if (!brand || !country) return

  const constants = CONSTANTS[country?.toUpperCase()]
  if (!constants) return

  return brand === 'zmarta'
    ? constants.GOOGLE_ANALYTICS.NAME.ZMARTA
    : constants.GOOGLE_ANALYTICS.NAME.BROKER
}

module.exports = { getGABrand }
